<ion-header>
  <ion-toolbar color="primary" no-border-bottom>
    <ion-buttons slot="start">
      <ion-button (click)="toggleGrid()">
        <!-- <ion-icon slot="icon-only" name="grid-outline" *ngIf="!showGrid"></ion-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-3x3 text-muted" viewBox="0 0 16 16" *ngIf="!showGrid">
          <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5zM1.5 1a.5.5 0 0 0-.5.5V5h4V1zM5 6H1v4h4zm1 4h4V6H6zm-1 1H1v3.5a.5.5 0 0 0 .5.5H5zm1 0v4h4v-4zm5 0v4h3.5a.5.5 0 0 0 .5-.5V11zm0-1h4V6h-4zm0-5h4V1.5a.5.5 0 0 0-.5-.5H11zm-1 0V1H6v4z"/>
        </svg>
        <!-- <ion-icon slot="icon-only" name="square-outline" *ngIf="showGrid"></ion-icon> -->
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grid-3x3" viewBox="0 0 16 16" *ngIf="showGrid">
          <path d="M0 1.5A1.5 1.5 0 0 1 1.5 0h13A1.5 1.5 0 0 1 16 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5zM1.5 1a.5.5 0 0 0-.5.5V5h4V1zM5 6H1v4h4zm1 4h4V6H6zm-1 1H1v3.5a.5.5 0 0 0 .5.5H5zm1 0v4h4v-4zm5 0v4h3.5a.5.5 0 0 0 .5-.5V11zm0-1h4V6h-4zm0-5h4V1.5a.5.5 0 0 0-.5-.5H11zm-1 0V1H6v4z"/>
        </svg>
      </ion-button>
    </ion-buttons>
    <ion-title *ngIf="photo">{{ 'APP.TYPE.' + photo.type | translate }}</ion-title>
    <ion-title *ngIf="!photo">{{ 'APP.TITLE.CameraOverlay' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="stopCamera()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content padding>
  <div id="imageAcquired" class="image-acquired d-flex justify-content-center align-items-center" *ngIf="imageUrl && !cameraActive">
    <!-- <div class="div-overlay contain" [class.grid]="showGrid" style="background-image: url('{{imageUrl}}');"></div> -->
    <img [class.h-100]="!mobile" [class.w-100]="mobile" [src]="imageUrl">
    <!-- <div class="div-overlay" [class.grid]="showGrid"></div> -->
  </div>
  <div id="cameraPreview" class="cameraPreview d-flex justify-content-center" [class.grid]="showGrid" *ngIf="cameraActive">
    <!-- <div class="div-overlay" [class.grid]="showGrid" *ngIf="cameraActive"> -->
      <!-- <img class="image-overlay" [src]="imageOverlay" alt="">       -->
    <!-- </div> -->
  </div>
  <div class="camera-controls">
    <div class="camera-bar"></div>
    <ion-button expand="full" id="close" (click)="stopCamera()">
      <ion-icon name="close-outline" slot="icon-only" size="large"></ion-icon>
    </ion-button>

    <ion-button expand="full" id="capture" (click)="captureImage()" *ngIf="cameraActive">
      <ion-icon name="camera-outline" slot="icon-only" size="large"></ion-icon>
    </ion-button>
    <ion-button expand="full" id="capture" (click)="returnToCamera()" *ngIf="!cameraActive">
      <ion-icon name="arrow-back" slot="icon-only" size="large"></ion-icon>
    </ion-button>

    <ion-button expand="full" id="flip" (click)="flipCamera()" *ngIf="cameraActive">
      <ion-icon name="camera-reverse-outline" slot="icon-only" size="large"></ion-icon>
    </ion-button>

    <ion-button expand="full" id="flip" (click)="acquirePhoto()" *ngIf="!cameraActive">
      <ion-icon name="share-outline" slot="icon-only" size="large"></ion-icon>
    </ion-button>
  </div>
</ion-content>
